import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { AppConfig } from '../app-config';
import { APP_CONFIG } from '../app-config.token';
import { MimeTypesMap } from '../common/constants/mime-types-map';
import { PARSE_DATES } from '../tokens/parse-dates.token';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  private http = inject(HttpClient);
  private config = inject<AppConfig>(APP_CONFIG);

  constructor() { }

  getFileAsBlob(route: string, id: number | null = null, fileName: string): Observable<string> {
    const url = `${this.config.resourceApiURI}/${route}${id ? '/' + id : ''}`;

    const context = new HttpContext().set(PARSE_DATES, false);

    return this.http
      .get<Blob>(url, {
        responseType: 'blob' as 'json',
        observe: 'response',
        context
      })
      .pipe(map((res) => window.URL.createObjectURL(res.body.slice(0, res.body.size, MimeTypesMap.get(fileName.split('.').pop().toLowerCase())))));
  }

  getFilesAsBlob(route: string, ids: number[] | null = null, fileName: string): Observable<string> {
    const url = `${this.config.resourceApiURI}/${route}`;

    const context = new HttpContext().set(PARSE_DATES, false);

    return this.http
      .post<Blob>(url,
        ids,
        {
          responseType: 'blob' as 'json',
          observe: 'response',
          context
        })
      .pipe(map((res) => window.URL.createObjectURL(res.body.slice(0, res.body.size, MimeTypesMap.get(fileName.split('.').pop().toLowerCase())))));
  }
}
